import { useGeneralContext } from "@/components/context/GeneralContext"
import { globalFetchPolicy } from "@/components/layout/fetchPolicies"
import { useGuideTopicQuery, useGuideTopicsTableQuery } from "@/graphql"
import { Modal } from "antd"
import classNames from "classnames"
import { FC, useEffect, useState } from "react"
import GuideContent from "../guide-content/GuideContent"

const UserGuide: FC = () => {
  const { isGuideOpened, setIsGuideOpened, openedGuideTopic } = useGeneralContext()
  const [open, setOpen] = useState(false)
  const [isMinimized, setIsMinimized] = useState(false)
  const [current, setCurrent] = useState<Maybe<string>>("")

  const { data, loading } = useGuideTopicsTableQuery({
    fetchPolicy: globalFetchPolicy,
    variables: { pagination: { limit: -1 }, sort: "createdAt:ASC" },
  })

  const { data: guideItem, loading: guideLoading } = useGuideTopicQuery({
    fetchPolicy: globalFetchPolicy,
    variables: {
      id: current ?? "",
    },
    skip: !current,
  })

  const guideTopics = data?.guideTopics?.data as GuideTopicEntity[]
  const firstTopicId = guideTopics?.[0]?.id
  const guideTopic = guideItem?.guideTopic?.data as GuideTopicEntity

  const videoAsset = guideTopic?.attributes?.video?.data?.attributes?.url
  const imagesSet = (guideTopic?.attributes?.images?.data as UploadFileEntity[]) ?? []
  const firstImageUrl =
    guideTopic?.attributes?.images?.data && guideTopic.attributes.images.data.length > 0
      ? guideTopic.attributes.images.data[0]?.attributes?.url
      : null

  useEffect(() => {
    const openedTopicId = guideTopics?.find(it => it?.attributes?.slug === openedGuideTopic)?.id
    setOpen(isGuideOpened)
    setCurrent(openedTopicId ?? firstTopicId)
  }, [firstTopicId, guideTopics, isGuideOpened, openedGuideTopic])

  const onClose = () => {
    setOpen(false)
    setIsGuideOpened(false)
  }
  const onMinimize = () => {
    setIsMinimized(!isMinimized)
  }
  const modalClasses = classNames({
    "guide-modal": true,
    "minimized": isMinimized,
  })
  return (
    <Modal
      width={800}
      mask={!isMinimized}
      maskClosable={false}
      footer={null}
      onCancel={onClose}
      open={open}
      wrapClassName={"guide-modal-wrapper"}
      className={modalClasses}
    >
      <GuideContent
        isMinimized={isMinimized}
        onClose={onClose}
        onMinimize={onMinimize}
        guideTopics={guideTopics}
        setCurrent={setCurrent}
        current={current}
        loading={loading || guideLoading}
        videoAsset={videoAsset}
        guideTopic={guideTopic}
        imagesSet={imagesSet}
        firstImageUrl={firstImageUrl}
      />
    </Modal>
  )
}

export default UserGuide
